import { Button } from "antd";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Signin = () => {
  const { loginWithRedirect } = useAuth0();
  const location = useLocation();
  const { t } = useTranslation();

  // Get invitation token from URL query params
  const queryParams = new URLSearchParams(location.search);
  const invitationToken = queryParams.get("invite");
  if (invitationToken) {
    localStorage.setItem("invitation_token", invitationToken);
  }

  return (
    <div className="login-page">
      <div className="login-header">
        <div className="logo-text">
          <img src="/assets/images/bg/logo-wide-white.png" alt="Logo" />
          <img src="/assets/images/bg/portal.png" alt="Portal" />
        </div>
      </div>

      <div className="icon-box">
        <img src="/assets/images/bg/star-pink.png" alt="star icon" />
      </div>

      <div className="login-content">
        <Button
          onClick={() => loginWithRedirect()}
          block
          type="primary"
          htmlType="submit"
          className="login-button"
        >
          {t("log_in")} {/* Translation key for "Log in" */}
        </Button>
      </div>
    </div>
  );
};

export default Signin;
